//accordian start
$(function(){
  $('.tab-wrapper.v1 .item .tab-btn a').click(function(e){
    e.preventDefault();
    
    var _item     = $(this).closest('.item');
    var _hasClass = 'selected';
    var _all      = $('.tab-wrapper.v1 .item');
        
    if(_item.hasClass(_hasClass)){
      _item.find('.tab-btn a em').removeClass('fa fa-minus').addClass('fa fa-plus')
            .closest('.item')
            .find('.tab-content')
           
            .slideUp(400, function(){
              _item.removeClass('selected');
            });
      
    }else{
      _all.find('.tab-btn a em').removeClass('fa fa-minus').addClass('fa fa-plus')
            .closest('.item')
            .find('.tab-content')
            .stop()
            .slideUp(400, function(){
              _all.removeClass('selected');
            });
      
      _item.find('.tab-btn a em').removeClass('fa fa-plus').addClass('fa fa-minus')
            .closest('.item')
            .find('.tab-content')
            .stop()
            .slideDown(400, function(){
              _item.addClass('selected');
            });
    }
  });
  
  $('.tab-wrapper.v2 .tab-btn a').click(function(e){
    e.preventDefault();
    
    var _this       = $(this);
    var _hasClass   = 'selected';
    var _category   = _this.data('category');
    var _content    = $('.tab-wrapper.v2 .tab-content .item');
    var _all        = $('.tab-wrapper.v2 .tab-btn a');
    
    if(_this.hasClass(_hasClass)){
      
    }else{
      _all.removeClass(_hasClass).find('em').removeClass('fa fa-plus').addClass('fa fa-minus');
      _this.addClass(_hasClass).find('em').removeClass('fa fa-minus').addClass('fa fa-plus');
      
      _content.each(function(){
        var _value   = $(this).data('value');
       
        $(this).removeClass(_hasClass).stop().hide();
        
        if(_value == _category){
          $(this).stop()
                  .fadeIn('slow', function(){
                    $(this).addClass(_hasClass);
                  });
        }
      });
    }
    
  });
});
//accordian end